import { render, staticRenderFns } from "./filter-btn.vue?vue&type=template&id=5370470e&"
import script from "./filter-btn.vue?vue&type=script&lang=js&"
export * from "./filter-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports